module.exports = __webpack_public_path__ + "img/icon-visibility-on.8ddc0ff1.svg";